import React from "react";
import { useLoading } from "../loading/LoadingContext.jsx";

// A single slim bar, fixed to the very top of the viewport, that sweeps
// while any page is fetching data (see LoadingContext). Non-blocking —
// the page underneath stays fully interactive.
export default function LoadingBar() {
  const { active } = useLoading();
  return <div className={`loading-bar${active ? " active" : ""}`} role="progressbar" aria-hidden={!active} aria-busy={active} />;
}
